import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonMenuButton,
} from '@ionic/react';
import { wallet, trophy } from 'ionicons/icons';
import { useWallet } from '../contexts/WalletContext';
import { useLevel } from '../contexts/LevelContext';
import { useAuth } from '../contexts/AuthContext';
import './AppHeader.css';

interface AppHeaderProps {
  title: string;
  showBackButton?: boolean;
  showMenuButton?: boolean;
  showWallet?: boolean;
  defaultHref?: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({ 
  title, 
  showBackButton = false,
  showMenuButton = false,
  showWallet = true,
  defaultHref = '/dashboard'
}) => {
  const { currentUser } = useAuth();
  const { balance, loading } = useWallet();
  const { level, levelProgress, nextLevelEarnings, stats, loading: levelLoading } = useLevel();

  // Calculate coins needed for next level
  const currentEarnings = stats?.lifetimeEarnings || 0;
  const coinsNeeded = nextLevelEarnings > 0 ? Math.max(0, nextLevelEarnings - currentEarnings) : 0;

  return (
    <IonHeader>
      <IonToolbar color="primary">
        {(showBackButton || showMenuButton) && (
          <IonButtons slot="start">
            {showMenuButton ? (
              <IonMenuButton />
            ) : (
              <IonBackButton defaultHref={defaultHref} />
            )}
          </IonButtons>
        )}
        <IonTitle>{title}</IonTitle>
        {showWallet && (
          <IonButtons slot="end">
            <IonButton 
              disabled={loading} 
              style={{ 
                '--padding-start': '8px', 
                '--padding-end': '12px',
                '--min-height': 'auto',
                height: 'auto'
              }}
            >
              <IonIcon icon={wallet} style={{ marginRight: '6px', fontSize: '20px' }} />
              <span style={{ 
                fontWeight: 'bold', 
                fontSize: '16px',
                display: 'inline-block',
                lineHeight: '1.2'
              }}>
                {loading ? '...' : balance.toLocaleString()}
              </span>
            </IonButton>
          </IonButtons>
        )}
      </IonToolbar>
      
      {/* Level Progress Bar */}
      {currentUser && !levelLoading && level !== null && (
        <div className="level-progress-container">
          <div className="level-progress-info">
            <div className="level-info-left">
              <IonIcon icon={trophy} className="level-icon level-icon-active" />
              <span className="level-text">Level {level}</span>
            </div>
            <div className="level-info-center">
              {coinsNeeded > 0 ? (
                <span className="level-coins-needed">{coinsNeeded.toLocaleString()} coins to next</span>
              ) : (
                <span className="level-coins-needed">Max Level!</span>
              )}
            </div>
            <div className="level-info-right">
              <IonIcon 
                icon={trophy} 
                className={`level-icon ${levelProgress >= 99 ? 'level-icon-active' : 'level-icon-inactive'}`} 
              />
              <span className="level-text">Level {level + 1}</span>
            </div>
          </div>
          <div className="level-progress-bar-wrapper">
            <div 
              className="level-progress-bar" 
              style={{ width: `${levelProgress}%` }}
            />
          </div>
          <div className="level-progress-percentage">
            {levelProgress}% to Level {level + 1}
          </div>
        </div>
      )}
    </IonHeader>
  );
};

export default AppHeader;

